export const SET_COMPANY = "SET_COMPANY";
export const NEW_COMPANY = "NEW_COMPANY";
export const GET_COMPANY = "GET_COMPANY";
export const SET_USER = "SET_USER";
export const SET_ROLE = "SET_ROLE";
export const SET_ACL = "SET_ACL";
export const LOGOUT_USER = "LOGOUT_USER";
export const WINDOW_DIMENSION = "WINDOW_DIMENSION";